export enum DataType {
	Boolean = "BOOLEAN",
	Date = "DATE",
	Number = "NUMBER",
	Text = "TEXT",
	Widget = "WIDGET",
}

export enum DataSubType {
	Chat = "CHAT",
	Table = "TABLE",
}
